<script setup lang="ts">
import { Editor } from "@tiptap/vue-3";
import SvgIcon from "~/components/Common/SvgIcon.vue";

export interface IActions {
  name: string;
  icon: string;
  label: string;
  function: Function;
  visible: boolean;
  shortcut?: string;
}

defineProps({
  action: {
    type: Object as PropType<IActions>,
  },
  editor: Editor,
});
</script>
<template>
  <div v-if="action" class="flex gap-1">
    <!-- <Tooltip :position="'top-mid'" append-to-body minified :forcePositionTop="5">
            <template #img> -->
    <div class="button-container" :class="{ 'is-active': editor?.isActive(action.name) }" @click="action?.function()">
      <SvgIcon
        class="svg-default-icon"
        :class="{ 'is-active': editor?.isActive(action.name) }"
        :name="action.icon"
      ></SvgIcon>
    </div>
  </div>
</template>
<style scoped lang="scss">
.button-container {
  @apply flex flex-row justify-center items-center rounded-[8px] w-fit;
  height: 36px;
  min-width: 36px;
  cursor: pointer;
  border: 1px solid var(--grey-lightest);
  color: var(--grey-lightest);
  transition: border-color 0.3s;

  &:hover,
  &:hover * {
    background-color: var(--grey-light);
    border-color: var(--grey-medium-light);
  }

  &:active,
  &:active * {
    border-color: var(--blue-deep-dark);
    color: var(--blue-deep-dark);
  }

  &.is-active {
    border-color: var(--primary-blue-color);
    color: var(--primary-blue-color);
  }

  &.is-active:hover,
  &.is-active:hover * {
    border-color: var(--blue-deep-dark);
    color: var(--blue-deep-dark);
    background-color: var(--grey-light);
  }
}

.svg-default-icon {
  @apply w-[16px] h-[16px] text-secondary-color;

  &:active {
    color: var(--blue-deep-dark);
  }

  &.is-active {
    color: var(--primary-blue-color);
  }
}
</style>
